/* global google:false */
import angular from 'angular';

module.exports = angular.module('market.directives.od-splash-map', [])
.directive('odSplashMap', function() {
  if (typeof(google) === 'undefined' || !google.maps) {
    console.warn('od-splash-map requires Google Maps JavaScript API.');
    return {};
  }

  const mapStyles = [
    {
      'stylers': [
        {
          'color': '#1c85e8'
        }
      ]
    },
    {
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
        {
      'featureType': 'poi',
      'stylers': [
        {
          'color': '#3291eb'
        }
      ]
    },
    {
      'featureType': 'water',
      'stylers': [
        {
          'color': '#0064c2'
        }
      ]
    },
    {
      'featureType': 'road',
      'stylers': [
        {
          'color': '#0064c2'
        }
      ]
    },
  ];

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      scope.$watch(attrs.odSplashMap, function(address) {
        if (!address) return;

        let center = new google.maps.LatLng(address.latitude, address.longitude);
        new google.maps.Map(element[0], {
          center: center,
          gestureHandling: 'none',
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          scrollwheel: false,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: false,
          zoom: 11,
          styles: mapStyles,
        });
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/directives/od-splash-map.js
 **/